import { UserStoreContext } from '../user-context';
import { createContextStoreHooks } from '@/shared/libs/create-context-store-hooks';

const { useSelector: useUserSelector } =
  createContextStoreHooks<any>(UserStoreContext);

// Подписка на срез user через внешний стор — не ре-рендерит на изменения других полей, в отличие от useUser()
export { useUserSelector };

// Готовые именованные селекторы на каждое поле user — единая точка правды
// вместо useUserSelector((user) => user?.поле), разбросанного по компонентам
export const useIsAuth = () => useUserSelector((user) => user?.isAuth);
export const useIsUserLoading = () =>
  useUserSelector((user) => user?.isUserLoading);
export const useUserCurrency = () => useUserSelector((user) => user?.currency);
export const useUserCurrencySymbol = () =>
  useUserSelector((user) => user?.currencySymbol);
export const useUserLimitEnabled = () =>
  useUserSelector((user) => user?.limitEnabled);
export const useUserPhone = () => useUserSelector((user) => user?.phone);
export const useUserId = () => useUserSelector((user) => user?.id);
export const useUserEmail = () => useUserSelector((user) => user?.email);
export const useUserPhoneConfirm = () =>
  useUserSelector((user) => user?.phoneConfirm);
export const useUserEmailConfirm = () =>
  useUserSelector((user) => user?.emailConfirm);
export const useUserWishlist = () => useUserSelector((user) => user?.wishlist);
export const useUserKycVerified = () =>
  useUserSelector((user) => user?.kycVerified);
export const useUserKycWarning = () =>
  useUserSelector((user) => user?.kycWarning);
export const useUserTelegram = () => useUserSelector((user) => user?.telegram);
export const useHasPhProfile = () =>
  useUserSelector((user) => user?.hasPhProfile);
export const useUserBirthday = () => useUserSelector((user) => user?.birthday);
export const useAppInstalled = () =>
  useUserSelector((user) => user?.appInstalled);
export const useIsMult = () => useUserSelector((user) => user?.isMult);
export const useUserPromoPopup = () =>
  useUserSelector((user) => user?.promoPopup);
export const useUserDepositBonus = () =>
  useUserSelector((user) => user?.userDepositBonus);
export const useUserDepositBonusConditionActive = () =>
  useUserSelector((user) => user?.userDepositBonusConditionActive);
export const useUserKycID = () => useUserSelector((user) => user?.kycID);
export const useUserAction = () => useUserSelector((user) => user?.action);
export const useUserHasPaymentInfo = () =>
  useUserSelector((user) => user?.hasPaymentInfo);
export const useUserAuthStatus = () =>
  useUserSelector((user) => user?.authStatus);
export const useUserTermsConfirmed = () =>
  useUserSelector((user) => user?.termsConfirmed);
export const useUserPlayResponsiblyConfirmed = () =>
  useUserSelector((user) => user?.playResponsiblyConfirmed);
export const useUserLang = () => useUserSelector((user) => user?.lang);
export const useIsReadApp = () => useUserSelector((user) => user?.isReadApp);
export const useHasUser = () => useUserSelector((user) => Boolean(user));
